export const SEO_CONFIG = {
  "/": {
    title: "连云港市海域使用权交易服务平台",
    keywords: "连云港市海域使用权交易服务平台",
    description: "连云港市海域使用权交易服务平台",
  },
  "/purchase/list/xmxx": {
    title: "连云港市海域使用权交易服务平台",
    keywords: "连云港市海域使用权交易服务平台",
    description: "连云港市海域使用权交易服务平台",
  },
};

/**
 * 获取当前路由的 SEO 配置
 * @param {string} path 路由路径
 * @param {Object} dynamicData 动态数据
 * @returns {Object} SEO 配置
 */
export function getSEOConfig(path, dynamicData = {}) {
  const cleanPath = path.replace(/\?.*$/, "").replace(/\/$/, "");
  let config = SEO_CONFIG[cleanPath] || SEO_CONFIG["/"];

  if (Object.keys(dynamicData).length > 0) {
    config = replaceDynamicData(config, dynamicData);
  }

  return config;
}

/**
 * 替换动态数据占位符
 */
function replaceDynamicData(config, dynamicData) {
  const result = { ...config };

  // 遍历所有属性进行占位符替换
  Object.keys(result).forEach((key) => {
    if (typeof result[key] === "string") {
      result[key] = replacePlaceholders(result[key], dynamicData);
    }
  });

  return result;
}

/**
 * 替换占位符
 */
function replacePlaceholders(text, data) {
  if (!text) return text;

  let result = text;
  result = result.replace(/\{title\}/g, data.title || "");
  result = result.replace(/\{region\}/g, data.region || "");
  result = result.replace(/\{category\}/g, data.category || "");
  result = result.replace(/\{orgName\}/g, data.orgName || "");
  result = result.replace(/\{categoryType\}/g, data.categoryType || "");
  result = result.replace(/\{budget\}/g, data.budget || "");
  result = result.replace(/\{status\}/g, data.status || "");

  return result;
}

/**
 * 设置页面 SEO
 * @param {Object} config SEO 配置
 */
export function setPageSEO(config, init) {
  if (!config) return;

  // 设置标题
  if (config.title) {
    document.title = init ? config.initTitle || config.title : config.title;
  }

  // 设置 meta
  setMetaTag("keywords", config.keywords);
  setMetaTag("description", config.description);
}

/**
 * 设置 meta 标签
 */
function setMetaTag(name, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }

  meta.content = content;
}
